import { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '@redux/store'; // Assuming you're using Redux
import { jwtDecode } from 'jwt-decode';

import { globalActions } from '@redux/slices/states/global/globalSlice';

// This function checks if the token has expired
const isTokenExpired = (token: string) => {
  try {
    const decoded: any = jwtDecode(token);
    return decoded.exp * 1000 < Date.now();
  } catch (error) {
    return true; // Consider the token invalid if there's an error
  }
};

const useJwtChecker = () => {
  const dispatch = useAppDispatch();
  const token = useAppSelector(state => state.global.user?.refreshToken); // Get the token from Redux or state
  const intervalId = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!token) {
      return;
    }

    // If an interval already exists, don't create a new one
    if (!intervalId.current) {
      intervalId.current = setInterval(() => {
        if (isTokenExpired(token)) {
          //console.log('Token has expired, logging out...');
          dispatch(globalActions.logout()); // Trigger the logout action
          clearInterval(intervalId.current!); // Clear the interval
          intervalId.current = null;
        }
      }, 30000); // 30-second interval
    }

    // Clear the interval when the component unmounts
    return () => {
      if (intervalId.current) {
        clearInterval(intervalId.current);
        intervalId.current = null;
      }
    };
  }, [token, dispatch]); // Runs when token or dispatch changes
};

export default useJwtChecker;
